import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { TabsComponent } from '@app-shared/components/tabs/tabs/tabs.component';

@Component({
  selector: 'app-tab',
  template: '<ng-content />',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  readonly title = input.required<string>();

  active: boolean = false;

  constructor() {
    const tabs = inject(TabsComponent);

    tabs.addTab(this);
  }
}
